import { Image } from 'expo-image';
import { Linking, Pressable } from 'react-native';
import { createStyleSheet, useStyles } from 'react-native-unistyles';

import { Text } from '@/ui';

interface FileThumbnailProps {
  url: string;
  onImagePress: () => void;
}

const isPdfUrl = (url: string) =>
  url.split('?')[0].toLowerCase().endsWith('.pdf');

export function FileThumbnail({ url, onImagePress }: FileThumbnailProps) {
  const { styles } = useStyles(stylesheet);

  if (isPdfUrl(url)) {
    return (
      <Pressable style={styles.pdf} onPress={() => Linking.openURL(url)}>
        <Text type="caption2" style={styles.pdfLabel}>
          PDF
        </Text>
      </Pressable>
    );
  }

  return (
    <Pressable onPress={onImagePress}>
      <Image source={{ uri: url }} style={styles.image} />
    </Pressable>
  );
}

const stylesheet = createStyleSheet((theme) => ({
  pdf: {
    width: 56,
    height: 56,
    borderRadius: 8,
    backgroundColor: theme.colors.card.default.backgroundColor,
    borderWidth: 1,
    borderColor: theme.colors.card.default.borderColor,
    justifyContent: 'center',
    alignItems: 'center',
  },
  pdfLabel: {
    color: theme.colors.text.secondary,
  },
  image: {
    width: 56,
    height: 56,
    borderRadius: 8,
  },
}));
